import { render, staticRenderFns } from "./pagos.vue?vue&type=template&id=503bb2f0&scoped=true&"
import script from "./pagos.vue?vue&type=script&lang=ts&"
export * from "./pagos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503bb2f0",
  null
  
)

export default component.exports